import React from 'react';
import {Button} from 'acud';

import './index.less';

export interface FormActionProps {
    handleOk: () => void;
    handleCancel: () => void;
}

export default (props: FormActionProps) => {
    const {handleOk, handleCancel} = props;
    return (
        <div className="acud-pro-form-pro-action-box">
            <Button
                type="primary"
                size="large"
                onClick={handleOk}
            >确定
            </Button>
            <Button
                size="large"
                onClick={handleCancel}
            >取消
            </Button>
        </div>
    );
};